import React from "react";

import TextBlockEditor from "../shared/blocks/TextBlockEditor"; // <-- adjust path
import CodeBlockEditor from "../shared/blocks/CodeBlockEditor"; // <-- adjust path

import LinkBlockEditor from "../project/blocks/LinkBlockEditor";
import CodeEditor from "../../../../../components/elements/CodeEditor";
import CodeLanguageEditor from "../project/blocks/CodeLanguageEditor";
import CodeWebLanguageEditor from "../project/blocks/CodeWebLanguageEditor";

export default function ProjectBlockTypeSwitcher({ block, onChange }) {
    if (!block || !block.type) return null;

    switch (block.type) {
        case "text":
            return (
                <TextBlockEditor
                    block={block}
                    onChange={onChange}
                />
            );

        case "code":
            return (
                <CodeLanguageEditor
                    value={block}
                    language={block?.config?.language || "javascript"}
                    onChange={onChange}
                />
            );

        case "code_web":
            return (
                <CodeWebLanguageEditor
                    value={block}
                    onChange={onChange}
                />
            );

        case "link":
            return (
                <LinkBlockEditor
                    value={block}
                    onChange={onChange}
                />
            );

        default:
            return (
                <div style={{ fontSize: 12, color: "crimson" }}>
                    Unknown block type: <code>{String(block.type)}</code>
                </div>
            );
    }
}
